/** @jsx jsx */
import { Fragment, useEffect, useState } from 'react'
import { jsx } from 'theme-ui'
import CalendarArticleHeader from './CalendarArticleHeader'
import CalendarArticleColumns from './CalendarArticleColumns'
import { array, bool } from 'prop-types'
import { useCalendarArticle } from '../../../hooks/useCalendarArticle'
import moment from 'moment/moment'

const CalendarArticleTable = ({ articleTable, isCalendarView }) => {
  const [data, setData] = useState([])
  const { initExpandableState } = useCalendarArticle()
  useEffect(() => {
    const sortedData = articleTable
      .sort((a, b) => {
        // Sort by month
        const aDate = moment(a.fields.columns[0].day)
        const bDate = moment(b.fields.columns[0].day)
        if (aDate.isBefore(bDate)) return -1
        if (aDate.isAfter(bDate)) return 1
        return 0
      })
      .map(item => {
        item.fields.title = isCalendarView
          ? moment(item.fields.columns[0].fields.day).format('MMMM')
          : item.fields.title
        const sortedColumns = item.fields.columns.sort((a, b) => {
          const dateA = new Date(a.fields.day).getUTCDate()
          const dateB = new Date(b.fields.day).getUTCDate()
          return dateA - dateB
        })
        return { ...item, columns: sortedColumns }
      })
    setData(sortedData)
  }, [articleTable])
  useEffect(() => {
    if (!data.length) return
    initExpandableState({ data, isCalendarView })
  }, [data])
  return (
    <Fragment>
      {data?.map((column, index) => {
        return (
          <Fragment key={column.sys.id}>
            <CalendarArticleHeader
              title={column.fields.title}
              index={index}
              id={column.sys.id}
            />
            <CalendarArticleColumns
              columns={column.columns}
              id={column.sys.id}
            />
          </Fragment>
        )
      })}
    </Fragment>
  )
}

CalendarArticleTable.propTypes = {
  articleTable: array,
  isCalendarView: bool,
}

export default CalendarArticleTable
